export default function navigation (document, moduleHTML, appEventEmitter) {
  const lightboxModal = document.querySelector('[data-js-lightbox-modal]')
  const lightboxModalName = lightboxModal.dataset.jsLightboxModal
  const lightboxModalToggles = document.querySelectorAll(`[data-js-lightbox-modal-toggle=${lightboxModalName}]`)

  lightboxModalToggles.forEach((element) => {
    element.addEventListener('click', (event) => lightboxModal.classList.toggle('hidden'))
  })
}
